import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useInputChange from "../../../utils/hooks/useInputChange";
import { isEmptyObject } from "../../../utils/validators/validators";
import AtEmployment from "./AtEmployment";
import CurrentEmployment from "./CurrentEmployment";

const EmploymentInfo = () => {
  const [editing, setEditing] = useState(false);
  const [editingCurrent, setEditingCurrent] = useState(false);
  const [employmentInfo, setEmploymentInfo] = useState({});

  const [error, setError] = useState({});

  // fetch records from redux state
  const { employment_information } = useSelector(
    (state) => state?.staff.staff_information
  );

  // Update Personal Info
  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      // dispatch(updateStaffContactInfo(staffInputData))
    }
  };

  // declare input fields variables
  const [staffInputData, setStaffInputData] = useState({
    department: "",
    designation: "",
    unit: "",
  });

  // Custom hook for input change
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  return (
    <div className='border p-4 rounded-3 mt-4 px-3 position-relative'>
      <h4 className='fw-bolder text-primary bg-white position-absolute profile-title'>
        Employment Information
      </h4>
      {employment_information && employment_information.length > 0 ? (
        <>
          <AtEmployment />
          <div className='clearfix'></div>
          <hr />
          <CurrentEmployment />

          <div className='clearfix'></div>
        </>
      ) : (
        <div className='alert alert-info'>No Record Found</div>
      )}
    </div>
  );
};

export default EmploymentInfo;
